import { KeyPrefix, Namespace } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useApplication } from 'src/context/ApplicationContext';
import { Proof } from 'src/types/api';

const DISABLED_TEXT_TRANSLATION_KEY_PREFIX: KeyPrefix<Namespace> = 'dup.submit';

export const useSubmissionValidation = ({
  isSubmitting,
  isTOSChecked,
  proofs
}: {
  isSubmitting: boolean;
  isTOSChecked: boolean;
  proofs: Proof[];
}) => {
  const { t } = useTranslation();
  const {
    connectedPayroll: { accountsConnected, isLoadingAccounts, isDeletingAccounts },
    bankLinking: { bankAccountsConnected, isLoadingBankAccounts, isDisconnectingAccount }
  } = useApplication();

  let disabledText = '';
  if (proofs.some((proof) => Boolean(proof.jobs_error?.length))) {
    disabledText = t(`${DISABLED_TEXT_TRANSLATION_KEY_PREFIX}.errorsInProofs`);
  } else if (!accountsConnected?.length && !proofs.length && !bankAccountsConnected?.length) {
    disabledText = t(`${DISABLED_TEXT_TRANSLATION_KEY_PREFIX}.hasNoConnectedPayrollAndProofs`);
  } else if (!isTOSChecked) {
    disabledText = t(`${DISABLED_TEXT_TRANSLATION_KEY_PREFIX}.tosNotChecked`);
  }

  return {
    disabledText,
    isSubmittable:
      !isLoadingAccounts &&
      !isDeletingAccounts &&
      !isLoadingBankAccounts &&
      !isDisconnectingAccount &&
      !isSubmitting &&
      !disabledText
  };
};
